export default __webpack_public_path__ + "static/media/pwa.6a7397bf.svg";